import React from 'react';

const serviceRequestConfig = {
    settings: {
        customScrollbars: false,
        layout: {
            style: 'layout1',
            config: {
                needUserInfo: true,
                redirectOn401: true,
                navbar: {
                    folded: true
                },
                footer: {
                    display: true
                }
            }
        }
    },
    routes: [
        {
            path: '/service-request/list',
            component: React.lazy(() => import('./service-requests'))
        },
        {
            path: '/service-request/pre-invoice/:serviceRequestId',
            component: React.lazy(() => import('./pre-invoice'))
        },
        {
            path: '/service-request/invoice/:serviceRequestId',
            component: React.lazy(() => import('./invoice'))
        },
        {
            path: '/service-request/new-service-request/:service?',
            component: React.lazy(() => import('./new-service-request'))
        },
    ]
};
export default serviceRequestConfig;